import * as React from "react";

import "./search-box.scss";

import {bindInput}     from "@Common/react/bind-input";
import {cs}            from "@Common/react/chain-services";
import {DebounceCache} from "@Common/react/debounce-cache";
import {Invoke}        from "@Common/react/invoke";
import {UseState}      from "@Common/react/use-state";
import {Responsive}    from "@Common/ui-components/responsive";

export const SearchBox = ({filter, initValue=""}) => cs(
    ["state", (_, next) => UseState({initValue, next})],

    ["responsive", (_, next) => {
        // @ts-ignore
        return <Responsive {...{
            sizes: {
                xs: 360,
            },
            next,
        }}/>;
    }],
    ["focusInput" , (_, next) => UseState({next})],
    ({responsive, focusInput, state}) => (
        <div className="search-box search-box-098">

            <div className="main">

                {isValid(state.value) && state.value !== filter.value && (
                    Invoke({
                        fn: () => filter.onChange(state.value),
                    })
                )}

                {cs(
                    ["cache", (_, next) => DebounceCache({
                        state,
                        next,
                    })],
                    ({cache}) => (
                        <input {...{
                            placeholder: responsive.lt("xs") ? "Search" : "Search by Property ID, Address, City or Zip",
                            onKeyDown: (e) => {
                                if (e.key === "Enter") {
                                    cache.flush();
                                }
                            },
                            onFocus: () => focusInput.onChange(true),
                            onBlur : () => {
                                cache.flush();
                                focusInput.onChange(false);
                            },
                            ...bindInput({
                                ...cache.state,
                                value: cache.state.value ?? filter.value,
                            }),
                            "xd-qa-type":"textbox",
                            "xd-qa-name":"search",
                        }}/>
                    ),
                )}

                <div className="search-controls">
                    {!!(state.value?.length || filter.value?.length) && (
                        <div
                            className="clear"
                            onClick={() => {
                                state.onChange("");
                                filter.onChange("");
                            }}
                        >
                            <i
                                className="fa fa-times-circle"
                                xd-qa-type="icon"
                                xd-qa-name="close"
                            />
                        </div>
                    )}
                </div>
            </div>

            {!isValid(state.value) ? (
                <div className="instruction error">
                    Please enter at least 3 characters.
                </div>
            ) : responsive.lt("xs") && (
                <div className="instruction">
                    Search by Property ID, Address, City or Zip
                </div>
            )}
        </div>
    ),
);

const isValid = (v) => !v || v.length >= 3;
